import { Game } from './game/Game.js';
import { UIManager, UIState } from './ui/UIManager.js';
import { ProgressStore } from './storage/ProgressStore.js';
import { OrientationController } from './game/OrientationController.js';

function showFatal(msg) {
  const root = document.getElementById('ui-root') || document.body;
  root.innerHTML = `<div class="fatal">${msg}</div>`;
}

function hasWebGL() {
  try {
    const c = document.createElement('canvas');
    return !!(window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl')));
  } catch {
    return false;
  }
}

function main() {
  if (!hasWebGL()) {
    showFatal('您的浏览器不支持 WebGL，请使用新版 Chrome/Safari/Firefox 再试。');
    return;
  }

  const canvas = document.getElementById('game-canvas');
  const uiRoot = document.getElementById('ui-root');
  const store = new ProgressStore();

  let ui;
  const game = new Game({
    canvas,
    onLevelComplete: (levelId, timeMs) => {
      store.recordTime(levelId, timeMs);
      ui.showLevelComplete(levelId, timeMs);
    },
    onBallFell: () => {
      // 掉洞动画由 BallController 处理，UI 侧暂无反应
    },
    onError: (msg) => {
      ui.showError(msg);
    },
    onIdleWarning: () => ui.showIdleHint(),
    onIdleWarningCleared: () => ui.hideIdleHint(),
  });

  ui = new UIManager(uiRoot, store, {
    onStartLevel: (levelId) => game.startLevel(levelId),
    onRestart: () => game.restartCurrentLevel(),
    onExit: () => game.exit(),
    getElapsedMs: () => game.getElapsedMs(),
    onToggleOrientation: async () => {
      if (game.isOrientationEnabled()) {
        game.disableOrientation();
        return { ok: true };
      }
      return await game.enableOrientation();
    },
    onCalibrateOrientation: () => game.calibrateOrientation(),
    isOrientationEnabled: () => game.isOrientationEnabled(),
    isOrientationSupported: () => OrientationController.isSupported(),
  });

  // 页面可见性：切标签页/最小化时暂停物理与计时
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) game.pause();
    else game.resume();
  });

  ui.setState(UIState.MAIN_MENU);
}

try {
  main();
} catch (e) {
  console.error(e);
  showFatal('游戏启动失败，请刷新重试。');
}
